// Helper function to initialize content-type help texts
export const initMediaContentTypeHelpers = ($context) => {
  // Initially display the correct help texts
  $context.find('[name*="[content_type]"]').each(function () {
    updateHelpText($(this));
  });
};

// Helper function to update a single container
const updateHelpText = ($select) => {
  const contentType = $select.val() || 'image';
  const $container = $select.closest('.card-body');

  // Hide all help texts
  $container.find('.help-text').hide();
  // Show the matching one
  $container.find('.help-text-' + contentType).show();

  // Set placeholder
  const $urlInput = $container.find('.image-upload-url');
  const $uploadWrapper = $container.find('.image-upload-wrapper');
  const $previewWrapper = $container.find('.image-preview-wrapper');
  const $uploadButton = $uploadWrapper.find('.image-upload-toggle');

  if (contentType === 'image' || contentType === 'logo' || contentType === 'attachement') {
    // Show upload button
    $uploadWrapper.show();
    $previewWrapper.show();

    // Adjust button text
    let buttonText = 'Bild vom Computer hochladen';

    if (contentType === 'logo') {
      buttonText = 'Logo vom Computer hochladen';
    } else if (contentType === 'attachement') {
      buttonText = 'Anhang vom Computer hochladen';
    }

    $uploadButton.text(buttonText);

    // Placeholder for upload
    $urlInput.attr('placeholder', 'Oder Link zur Datei einfügen');

    // URL field not readonly (in case it was previously set to readonly)
    if (!$urlInput.val()) {
      $urlInput.attr('readonly', false);
    }
  } else {
    // Hide upload button for video/audio
    $uploadWrapper.hide();
    $previewWrapper.hide();

    // Placeholder for embed code
    $urlInput.attr(
      'placeholder',
      'Embed-Code hier einfügen (kompletter <iframe>...</iframe> Code)'
    );

    // URL field not readonly, so embed code can be entered
    $urlInput.attr('readonly', false);
  }
};

$(function () {
  // Initialize all existing forms on first load
  initMediaContentTypeHelpers($(document));

  // Update help text when content type changes
  // $(document).on() also works for dynamically added elements
  $(document).on('change', '[name*="[content_type]"]', function () {
    updateHelpText($(this));
  });

  // Validation when pasting embed codes
  $(document).on('blur', '.image-upload-url', function () {
    const value = $(this).val();
    const $container = $(this).closest('.card-body');
    const contentType = $container.find('[name*="[content_type]"]').val();

    if ((contentType === 'video' || contentType === 'audio') && value.trim() !== '') {
      if (value.includes('<iframe') && !value.includes('width="100%"')) {
        // Show warning
        if (!$container.find('.embed-warning').length) {
          $(this).after(
            '<div class="alert alert-warning embed-warning mt-2"><strong>Achtung:</strong> Der Embed-Code sollte <code>width="100%"</code> enthalten, damit die Darstellung in der App korrekt ist. <br /> <a href="#" class="fix-width-link">Automatisch korrigieren</a></div>'
          );
        }
      } else {
        $container.find('.embed-warning').remove();
      }
    }
  });

  // Auto-fix for width
  $(document).on('click', '.fix-width-link', function (e) {
    e.preventDefault();

    const $input = $(this).closest('.form-group').find('.image-upload-url');
    const value = $input.val();
    const fixed = value.replace(/width="[^"]*"/, 'width="100%"');

    $input.val(fixed);
    $(this).closest('.embed-warning').remove();
  });
});
